import { LoadingButton } from '@mui/lab';
import { Alert, Box } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import { TextInput } from '../../../text-input/TextInput';
import { FindQualificationHeader } from '../../shared/QualificationFormHeader';
import { GuestUserFindQualificationInputs } from '../types';

interface QualificationFindFormProps {
  form: UseFormReturn<GuestUserFindQualificationInputs>;
  onSubmit: (data: GuestUserFindQualificationInputs) => void;
  isFetching: boolean;
  isError: boolean;
  errorMessage?: string;
}
export const QualificationFindForm: React.FC<QualificationFindFormProps> = ({
  form: {
    formState: { errors },
    handleSubmit,
    register,
  },
  isFetching,
  isError,
  errorMessage,
  onSubmit,
}) => {
  return (
    <Box>
      <FindQualificationHeader />
      {isError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          FieldProps={{ ...register('email'), type: 'email' }}
          required
          error={errors.email?.message}
          id="eligibility-qualification-find-email-field"
          placeholder="Your Email Address"
          label="Email"
        />
        <LoadingButton loading={isFetching} type="submit" variant="contained" sx={{ width: 1 }}>
          Find my qualification
        </LoadingButton>
      </form>
    </Box>
  );
};
